import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import { CarouselBase } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Carousel/CarouselBase";
import { Context } from "@faire/retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { SampleBrandTile } from "@faire/retailer-visitor-shared/components/SampleBrandTile/SampleBrandTile";
import { isNotUndefined } from "@faire/web--source/common/typescriptUtils";
import { ILayoutElement } from "@faire/web-api--source/indigofair/data/ILayoutElement";
import * as React from "react";
export var SampleRequestCarousel = function(props) {
    var _React_useContext = React.useContext(Context), layoutElement = _React_useContext.layoutElement, requestId = _React_useContext.requestId, onItemClick = _React_useContext.onItemClick, onVisible = _React_useContext.onVisible;
    var layout_element_data = layoutElement.layout_element_data;
    var items = layout_element_data.map(function(elementData) {
        return elementData.simple_brand_tile;
    }).filter(isNotUndefined);
    var sourcePage = getCarouselSource(layoutElement.display_page);
    var onItemClickHandler = function(token) {
        var on_click_event_name = layoutElement.on_click_event_name;
        if (on_click_event_name && token) {
            onItemClick === null || onItemClick === void 0 ? void 0 : onItemClick(on_click_event_name, requestId, token);
        }
    };
    var renderSampleBrandTile = function(simpleBrandTile) {
        return /*#__PURE__*/ _jsx(SampleBrandTile, {
            simpleBrandTile: simpleBrandTile,
            sourcePage: sourcePage,
            onClick: onItemClickHandler
        }, simpleBrandTile.token);
    };
    var commonProps = _object_spread({
        items: items,
        renderItem: renderSampleBrandTile,
        itemsPerSlide: {
            mobileAndAbove: 1,
            tabletAndAbove: 3,
            desktopAndAbove: 5
        },
        peekGapPercent: 50,
        swipeableLeftPadding: 0
    }, props);
    var CarouselBaseComponent = CarouselBase;
    var onItemsVisible = function(items) {
        var itemTokens = items.map(function(item) {
            return item === null || item === void 0 ? void 0 : item.token;
        });
        if (layoutElement.on_click_event_name) {
            var _itemTokens_join;
            onVisible === null || onVisible === void 0 ? void 0 : onVisible(layoutElement.on_click_event_name, requestId, (_itemTokens_join = itemTokens === null || itemTokens === void 0 ? void 0 : itemTokens.join(" ")) !== null && _itemTokens_join !== void 0 ? _itemTokens_join : "");
        }
    };
    var _props_peekNextPercent, _props_itemGap;
    return /*#__PURE__*/ _jsx(CarouselBaseComponent, _object_spread({
        peekNextPercent: (_props_peekNextPercent = props.peekNextPercent) !== null && _props_peekNextPercent !== void 0 ? _props_peekNextPercent : {
            mobileAndAbove: 50,
            tabletAndAbove: 0
        },
        itemGap: (_props_itemGap = props.itemGap) !== null && _props_itemGap !== void 0 ? _props_itemGap : {
            mobileAndAbove: 16,
            tabletAndAbove: 24
        },
        onItemsVisible: onItemsVisible
    }, commonProps));
};
var getCarouselSource = function(displayPage) {
    switch(displayPage){
        case ILayoutElement.DisplayPage.CATEGORY_PAGE:
            return "C1";
        case ILayoutElement.DisplayPage.HOMEPAGE:
            return "HOME";
        case ILayoutElement.DisplayPage.LANDING_PAGE:
            return "LANDING-PAGE";
        default:
            return undefined;
    }
};
